exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".table__body--2IAzp,.table__narrowWrapper--23L4Q,.table__scroller--1S4_5,.table__table--3bKbs,.table__wrapper--3OYlZ{-webkit-box-sizing:border-box;box-sizing:border-box;font-family:Source Sans Pro,sans-serif}.table__table--3bKbs{border-collapse:inherit;width:100%}.table__wrapper--3OYlZ{border-bottom:1px solid #d8d8d8;border-top:1px solid #d8d8d8;display:block;overflow:hidden;position:relative;width:100%}.table__scroller--1S4_5{display:block;margin-left:175.008px;margin-left:10.938rem;overflow-x:scroll;width:calc(100% - 10.938rem)}.table__body--2IAzp{vertical-align:middle}.table__narrowWrapper--23L4Q{max-width:500px;max-width:31.25rem}", ""]);

// exports
exports.locals = {
	"table": "table__table--3bKbs",
	"wrapper": "table__wrapper--3OYlZ",
	"scroller": "table__scroller--1S4_5",
	"body": "table__body--2IAzp",
	"narrowWrapper": "table__narrowWrapper--23L4Q table__wrapper--3OYlZ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"sourceMap":true,"config":{"path":"/var/www/prb-datafinder/client/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./app/components/table/table.scss
// module id = 642
// module chunks = 0